<template>
    <div id="data-list-list-view" class="data-list-container">
        
        <add-bill
                :isSidebarActive="showSidebar"
                @closeSidebar="toggleDataSidebar"
                :customers="customers"
                :loadBillsEvent="listOfBill"
        />

        <vs-table
                ref="table"
                :max-items="itemsPerPage"
                search
                :data="bills"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <!--
                <div v-if="is_authorize()" class="flex flex-wrap-reverse items-center data-list-btn-container">
                    <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                    >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary" @click="addNew">Nouvelle facture</span>
                    </div>
                </div>
                -->
                
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="itemsPerPage = 4">
                            <span>4</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage = 10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage = 15">
                            <span>15</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage = 20">
                            <span>20</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="invoice">Facture</vs-th>
                <vs-th sort-key="customer">Entreprise</vs-th>
                <vs-th sort-key="amount_ttc">Montant TTC</vs-th>
                <vs-th sort-key="payments">Règlements</vs-th>
                <vs-th sort-key="status">Etat</vs-th>
                <vs-th sort-key="echeance">Echéance</vs-th>
                <vs-th v-if="is_authorize()">Action</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <span>{{ tr.reference }}</span>
                    </vs-td>
                    <vs-td>
                        <span>{{ tr.customer}}</span>
                    </vs-td>
                    <vs-td>
                        <span class="font-semibold">{{ tr.amount }} F CFA</span>
                    </vs-td>
                    <vs-td>
                        <span>{{ tr.nbr_reg ? tr.nbr_reg : 0 }}</span>
                    </vs-td>
                    <vs-td>
                        <vs-chip :color="tr.is_sold ? 'success' : 'danger'">{{ tr.is_sold ? 'Réglée' : 'Non Réglée' }}</vs-chip>
                    </vs-td>
                    <vs-td>
                        <span>{{ tr.deadline}}</span>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap" v-if="is_authorize()">
                        <div class="flex">
                            <vx-tooltip text="Supprimer">
                                <feather-icon style="cursor: pointer" @click="deleteUpload(tr)"
                                              icon="DeleteIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
    </div>
</template>

<script>
    import addBill from "./addBill";

    export default {
        components: { addBill },
        name: "bills",
        data: () => ({
            last_page: 1,
            page: 1,
            itemsPerPage: 10,
            bills: [],
            showSidebar: false,
            customers: [],
        }),
        mounted() {
            this.listOfBill()
        },
        watch: {
            page () {
                this.listOfBill();
            }
        },
        methods:{

            toggleDataSidebar(val = false) {
                this.showSidebar = val;
            },

            deleteUpload(el){
                if (confirm('Voulez vous vraiment supprimer ?')){
                    this.$vs.loading()
                    this.$http.post('/bills/remove/upload',
                        {id: el.id, upload: el.upload_bills_id, amount: el.amount }
                    ).then((response) => {
                        this.$vs.loading.close()
                        if (response.data.status){
                            let index = this.bills.indexOf(el)
                            this.bills.splice(index, 1)
                            window.GETCCMT.notification('success','Suppression', 'Opération effectuée')
                        }else window.GETCCMT.notification('error','Echec !', 'Opération échouée')
                    }).catch((error) =>{
                        this.$vs.loading.close()
                        if (error.response.status === 401){
                            this.$router.push('/login')
                        }
                    })
                }
            },

            getCustomer(){
                this.$vs.loading()
                this.$http.get('/customers').then((response) => {
                    this.customers = response.data
                    this.$vs.loading.close()
                }).catch((error) =>{
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }
                })
            },

            addNew() {
                this.sidebarData = {};
                this.getCustomer()
                this.toggleDataSidebar(true);
            },

            is_authorize(){
                if(this.$store.state.is_admin() || this.$store.state.is_chargerClientele()){
                    return true;
                }
                return false;
            },

            listOfBill(){
                this.$vs.loading()
                this.$http.get('/bills?page='+this.page).then((response) => {
                    this.bills = response.data.data
                    this.last_page = response.data.last_page;
                    this.$vs.loading.close()
                }).catch((error) =>{
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                        this.$router.push('/login')
                    }
                })
            },
        }
    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {
            @media (max-width: 689px) {
                .vs-table--search {
                    margin-left: 0;
                    max-width: unset;
                    width: 100%;

                    .vs-table--search-input {
                        width: 100%;
                    }
                }
            }

            @media (max-width: 461px) {
                .items-per-page-handler {
                    display: none;
                }
            }

            @media (max-width: 341px) {
                .data-list-btn-container {
                    width: 100%;

                    .dd-actions,
                    .btn-add-new {
                        width: 100%;
                        margin-right: 0 !important;
                    }
                }
            }

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap;
                margin-left: 1.5rem;
                margin-right: 1.5rem;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                    td {
                        padding: 20px;
                        &:first-child {
                            border-top-left-radius: 0.5rem;
                            border-bottom-left-radius: 0.5rem;
                        }
                        &:last-child {
                            border-top-right-radius: 0.5rem;
                            border-bottom-right-radius: 0.5rem;
                        }
                    }
                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }
                th.td-check {
                    padding: 0 15px !important;
                }
                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>